import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_onboarding-product_page_click_return_to_results-click';

/**
 * An event that is called when the retailer clicks the &quot;return to results&quot; button on the product page. Destination param represents the category&#x2F;discover page they are being redirected to.
 */
export function trackRetailerOnboardingProductPageClickReturnToResultsClick(
  destination: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { destination },
  });
}
